<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m9 13.75c-2.34 0-7 1.17-7 3.5v1.75h14v-1.75c0-2.33-4.66-3.5-7-3.5zm-4.66 3.25c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25zm4.66-5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5zm0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44v1.75h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zm-1.04-1.81c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
    />
  </svg>
</template>
